import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { folderListResponse } from '../../insights.interface';
import { ErrorHandlingService } from '../../../../core/services/error-handling.service';
import { ApiResponse } from '../../../../core/models/api-response.models';
import { AuditFieldChange } from '../../../audit-logs/audit-logs.interface';

@Injectable({
  providedIn: 'root',
})
export class AttachmentFolderService {
  private readonly BASE_URL = `${environment.apiUrl}/attachmentFolder`;
  private readonly http = inject(HttpClient);
  private readonly errorHandler = inject(ErrorHandlingService);

  getFolders(caseId: number): Observable<folderListResponse> {
    return this.http
      .get<folderListResponse>(`${this.BASE_URL}/folder-list?caseId=${caseId}`)
      .pipe(
        tap(response => {
          return response;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  createFolder(payload: {
    caseId: number;
    name: string;
    _modifiedFields?: AuditFieldChange[];
  }): Observable<ApiResponse<boolean>> {
    return this.http
      .post<ApiResponse<boolean>>(`${this.BASE_URL}/create`, payload)
      .pipe(
        tap((response: ApiResponse<boolean>) => {
          return response;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
}
